// extracted by mini-css-extract-plugin
export default {"container":"eL-z","modal":"fL-z","dimensions":"gL-z","brandName":"hL-z","productName":"iL-z","labelValue":"jL-z","recipientEmail":"kL-z","recommendedFit":"lL-z","hiddenField":"mL-z"};